import React from 'react'

const About = () => {
	return (
		<section className="section about-section">
			<h1 className="section-title">about us</h1>
			<p>
				Lorem ipsum dolor, sit amet consectetur
				adipisicing elit. Quisquam possimus voluptas
				maiores voluptatibus dicta aut maxime placeat
				nihil! Earum iusto quae porro assumenda ut
				fuga, sunt deleniti, nihil explicabo eligendi
				atque eius. Quo obcaecati labore esse deleniti
				nihil aliquid saepe?
			</p>
		</section>
	)
}

export default About
